module.exports = __webpack_public_path__ + "static/warehouse-6b9a093e0ba4a3795209e94bf174f2be.png";